function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * @module ol/proj/proj4
 */
import { addCoordinateTransforms, addEquivalentProjections, addProjection, createSafeCoordinateTransform } from '../proj.js';
import Projection from './Projection.js';
import { get as getCachedProjection } from './projections.js';
import { get as getTransform } from './transforms.js';

/**
 * @type {import("proj4")|null}
 */
var registered = null;

/**
 * @return {boolean} Proj4 has been registered.
 */
export function isRegistered() {
  return !!registered;
}

/**
 * Unsets the shared proj4 previously set with register.
 */
export function unregister() {
  registered = null;
}

/**
 * Make projections defined in proj4 (with `proj4.defs()`) available in
 * OpenLayers. Requires proj4 >= 2.8.0.
 *
 * This function should be called whenever changes are made to the proj4
 * registry, e.g. after calling `proj4.defs()`. Existing transforms will not be
 * modified by this function.
 *
 * @param {import("proj4")} proj4 Proj4.
 * @api
 */
export function register(proj4) {
  registered = proj4;
  var projCodes = Object.keys(proj4.defs);
  var len = projCodes.length;
  var i, j;
  for (i = 0; i < len; ++i) {
    var code = projCodes[i];
    if (!getCachedProjection(code)) {
      var def = proj4.defs(code);
      var units = /** @type {import("./Units.js").Units} */def.units;
      if (!units && def.projName === 'longlat') {
        units = 'degrees';
      }
      addProjection(new Projection({
        code: code,
        axisOrientation: def.axis,
        metersPerUnit: def.to_meter,
        units: units
      }));
    }
  }
  for (i = 0; i < len; ++i) {
    var code1 = projCodes[i];
    var proj1 = getCachedProjection(code1);
    for (j = 0; j < len; ++j) {
      var code2 = projCodes[j];
      var proj2 = getCachedProjection(code2);
      if (!getTransform(code1, code2)) {
        if (proj4.defs[code1] === proj4.defs[code2]) {
          addEquivalentProjections([proj1, proj2]);
        } else {
          var transform = proj4(code1, code2);
          addCoordinateTransforms(proj1, proj2, createSafeCoordinateTransform(proj1, proj2, transform.forward), createSafeCoordinateTransform(proj2, proj1, transform.inverse));
        }
      }
    }
  }
}

/**
 * @param {number} code The EPSG code.
 * @return {Promise<string>} The proj4 definition.
 */
var epsgLookup = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(code) {
    var response;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetch("https://epsg.io/".concat(code, ".proj4"));
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          throw new Error("Unexpected response from epsg.io: ".concat(response.status));
        case 2:
          return _context.a(2, response.text());
      }
    }, _callee);
  }));
  return function epsgLookup(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Set the lookup function for getting proj4 definitions given an EPSG code.
 * By default, the {@link module:ol/proj/proj4.fromEPSGCode} function uses the
 * epsg.io website for proj4 definitions.  This can be changed by providing a
 * different lookup function.
 *
 * @param {function(number):Promise<string>} func The lookup function.
 * @api
 */
export function setEPSGLookup(func) {
  epsgLookup = func;
}

/**
 * Get the current EPSG lookup function.
 *
 * @return {function(number):Promise<string>} The EPSG lookup function.
 */
export function getEPSGLookup() {
  return epsgLookup;
}

/**
 * Get a projection from an EPSG code.  This function fetches the projection
 * definition from the epsg.io website, registers this definition for use with
 * proj4, and returns a configured projection.  You must call import proj4 and
 * call {@link module:ol/proj/proj4.register} before using this function.
 *
 * If the projection definition is already registered with proj4, it will not
 * be fetched again (so it is ok to call this function multiple times with the
 * same code).
 *
 * @param {number|string} code The EPSG code (e.g. 4326 or 'EPSG:4326').
 * @return {Promise<Projection>} The projection.
 * @api
 */
export function fromEPSGCode(_x2) {
  return _fromEPSGCode.apply(this, arguments);
}

/**
 * Generate an EPSG lookup function which uses the MapTiler Coordinates API to find projection
 * definitions which do not require proj4 to be configured to handle `+nadgrids` parameters.
 * Call {@link module:ol/proj/proj4.setEPSGLookup} use the function for lookups
 * `setEPSGLookup(epsgLookupMapTiler('{YOUR_MAPTILER_API_KEY_HERE}'))`.
 *
 * @param {string} key MapTiler API key.  Get your own API key at https://www.maptiler.com/cloud/.
 * @return {function(number):Promise<string>} The EPSG lookup function.
 * @api
 */
function _fromEPSGCode() {
  _fromEPSGCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(code) {
    var proj4, epsgCode, _t, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (typeof code === 'string') {
            code = parseInt(code.split(':').pop(), 10);
          }
          proj4 = registered;
          if (proj4) {
            _context3.n = 1;
            break;
          }
          throw new Error('Proj4 must be registered first with register(proj4)');
        case 1:
          epsgCode = 'EPSG:' + code;
          if (!proj4.defs(epsgCode)) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, getCachedProjection(epsgCode));
        case 2:
          _t = proj4;
          _t2 = epsgCode;
          _context3.n = 3;
          return epsgLookup(code);
        case 3:
          _t.defs.call(_t, _t2, _context3.v);
          register(proj4);
          return _context3.a(2, getCachedProjection(epsgCode));
      }
    }, _callee3);
  }));
  return _fromEPSGCode.apply(this, arguments);
}
export function epsgLookupMapTiler(key) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(code) {
      var response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return fetch("https://api.maptiler.com/coordinates/search/code:".concat(code, ".json?transformations=true&exports=true&key=").concat(key));
          case 1:
            response = _context2.v;
            if (response.ok) {
              _context2.n = 2;
              break;
            }
            throw new Error("Unexpected response from maptiler.com: ".concat(response.status));
          case 2:
            return _context2.a(2, response.json().then(function (json) {
              var results = json['results'];
              if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
                var result = results.filter(function (r) {
                  var _r$id, _r$id2;
                  return ((_r$id = r['id']) === null || _r$id === void 0 ? void 0 : _r$id['authority']) === 'EPSG' && ((_r$id2 = r['id']) === null || _r$id2 === void 0 ? void 0 : _r$id2['code']) === code;
                })[0];
                if (result) {
                  var _result$exports2;
                  var transforms = result['transformations'];
                  if ((transforms === null || transforms === void 0 ? void 0 : transforms.length) > 0) {
                    var _transforms$filter$so;
                    // use default transform if it does not require grids
                    var defaultTransform = result['default_transformation'];
                    if (transforms.filter(function (t) {
                      var _t$id, _t$id2, _t$grids;
                      return ((_t$id = t['id']) === null || _t$id === void 0 ? void 0 : _t$id['authority']) === (defaultTransform === null || defaultTransform === void 0 ? void 0 : defaultTransform['authority']) && ((_t$id2 = t['id']) === null || _t$id2 === void 0 ? void 0 : _t$id2['code']) === (defaultTransform === null || defaultTransform === void 0 ? void 0 : defaultTransform['code']) && ((_t$grids = t['grids']) === null || _t$grids === void 0 ? void 0 : _t$grids.length) === 0;
                    }).length > 0) {
                      var _result$exports;
                      return (_result$exports = result['exports']) === null || _result$exports === void 0 ? void 0 : _result$exports['proj4'];
                    }
                    // otherwise use most accurate alternative without grids
                    var transform = (_transforms$filter$so = transforms.filter(function (t) {
                      var _t$grids2, _t$target_crs, _t$target_crs2;
                      return ((_t$grids2 = t['grids']) === null || _t$grids2 === void 0 ? void 0 : _t$grids2.length) === 0 && ((_t$target_crs = t['target_crs']) === null || _t$target_crs === void 0 ? void 0 : _t$target_crs['authority']) === 'EPSG' && ((_t$target_crs2 = t['target_crs']) === null || _t$target_crs2 === void 0 ? void 0 : _t$target_crs2['code']) === 4326 && t['deprecated'] === false && t['usable'] === true;
                    }).sort(function (t1, t2) {
                      return t1['accuracy'] - t2['accuracy'];
                    })[0]) === null || _transforms$filter$so === void 0 || (_transforms$filter$so = _transforms$filter$so['exports']) === null || _transforms$filter$so === void 0 ? void 0 : _transforms$filter$so['proj4'];
                    if (transform) {
                      return transform;
                    }
                  }
                  // fallback to default
                  return (_result$exports2 = result['exports']) === null || _result$exports2 === void 0 ? void 0 : _result$exports2['proj4'];
                }
              }
            }));
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}